import { IsString, IsUUID, IsBoolean, IsEnum, IsOptional } from 'class-validator';
import { OrganizationType } from '../../../enums/clients/organization-type.enum';

export class CreateProductOrganizationRoleRequestDto {
    /**
     * Product ID
     * @example 'f47ac10b-58cc-4372-a567-0e02b2c3d479'
     */
    @IsOptional()
    @IsUUID()
    productId?: string;

    /**
     * Organization ID
     * @example 'f47ac10b-58cc-4372-a567-0e02b2c3d480'
     */
    @IsUUID()
    organizationId: string;

    /**
     * Role type for this organization
     * @example 'FABRICATOR'
     */
    @IsEnum(OrganizationType)
    roleType: OrganizationType;

    /**
     * If multiple organizations for same role, indicates primary
     * @example true
     */
    @IsOptional()
    @IsBoolean()
    isPrimaryForRole?: boolean;

    /**
     * Specific notes for this organization role
     * @example 'Primary fabricator for North American distribution'
     */
    @IsOptional()
    @IsString()
    notes?: string;
} 